import { Component, OnInit,Inject, OnDestroy } from '@angular/core';
import { MatDialogRef , MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MultiLanguageService } from '../../core/multi-language/multi-language.service';

@Component({
  selector: 'app-store-dialog',
  templateUrl: './store-dialog.component.html',
  styleUrls: ['./store-dialog.component.scss']
})
export class StoreDialogComponent implements OnInit, OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  store: any = {}; 
  cancelNote: string;
  storeSearch: FormControl = new FormControl();
  private subscriptionList = new Subscription();
  filterStore: string[];
  storeList: any[];
  cashCounterList: any[];
  filterCashCounter: string[];
  cashCounter: any;
  cashCounterSearch: FormControl = new FormControl();
  isDefaultSelectionRequired: boolean = false;
  isDefaultCashCounter: boolean = false;
  workstations: any[];
  isWorkStationRequired: boolean = false;
  workstation: any = {};
  workstationSearch: FormControl = new FormControl();
  filterWorkstations: string[];
  isDisabled: boolean= false;
  cashCounterName: string = "";

  constructor(
    public dialogRef: MatDialogRef<StoreDialogComponent>,
   public snackBar: MatSnackBar,
   @Inject(MAT_DIALOG_DATA) public data,
   private langService: MultiLanguageService
  ) { }

  ngOnInit() {
    this.storeList = this.data.store;
    this.filterStore = this.storeList;
    this.cashCounterList = this.data.cashCounter;
    this.filterCashCounter = this.cashCounterList;
    this.store = (this.data.defaultStore && this.storeList)
      ? this.storeList.find(
        element => element && element.storeCode === this.data.defaultStore.storeCode
      ) || null
      : null;
    // this.cashCounter = (this.data.setDefaultCashCounter && this.cashCounterList)
    //   ? this.cashCounterList.find(
    //     element => element && element.cashCounterCode === this.data.setDefaultCashCounter.cashCounterCode
    //   ) || null
    //   : null;
    this.cashCounter = this.data.setDefaultCashCounter;
    if(this.cashCounter){
      this.cashCounterName = this.cashCounter.desc;
      this.isDisabled = true;
    }
    else{
      this.cashCounterName = "";
      this.isDisabled = false;
    }
    let isDefaultSelectionRequired = this.data.isDefaultSelectionRequired;
    let isDefaultCashCounter = this.data.isDefaultCashCounter;
    this.workstations = this.data.workstations;
    this.filterWorkstations = this.workstations;
    let isWorkStationRequired = this.data.isWorkStationRequired;

    if (this.store && isDefaultSelectionRequired) {
      this.isDefaultSelectionRequired = true;
    } else {
      this.isDefaultSelectionRequired = false;
    }
    if (this.cashCounterList && isDefaultCashCounter) { //this.cashCounter && isDefaultCashCounter
      this.isDefaultCashCounter = true;
    } else {
      this.isDefaultCashCounter = false;
    }
    if(isWorkStationRequired){
      this.isWorkStationRequired = true;
    }
    else{
      this.isWorkStationRequired = false;
    }
  
    this.onChanges();
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onChanges() {
    this.subscriptionList.add(
      this.storeSearch.valueChanges.subscribe((value) => {
        this.filterStore = this.storeList.filter((i) =>
          i.storeDesc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.cashCounterSearch.valueChanges.subscribe((value) => {
        this.filterCashCounter = this.cashCounterList.filter((i) =>
          i.cashCounterDesc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.workstationSearch.valueChanges.subscribe((value) => {
        this.filterWorkstations = this.workstations.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }


  /**
   * Save on click
   */
  onSaveClick(): void {
    if (this.store && !this.store.storeId) {
      this.snackBar.open("Info", "Please select Store", {
        duration: 3000
      });
    } else if (this.cashCounter && !this.cashCounter.cashCounterId) {
      this.snackBar.open("Info", "Please select Cash Counter", {
        duration: 3000
      });
    } else {
      var data = {
        store: this.store ? this.store : null,
        cashCounter: this.cashCounter? this.cashCounter : null,
        workstation : this.workstation ? this.workstation : null
      }
      this.dialogRef.close(data);
    }
  }
}
